import { createContext, useContext, useEffect } from "react";

export const StatusBarContext = createContext(null);

export function useStatusBarLayer({ id, color, priority = 0, enabled = true }) {
  const ctx = useContext(StatusBarContext);

  useEffect(() => {
    if (!ctx || !enabled || !id || !color) return;
    ctx.register({ id, color, priority });
    return () => ctx.unregister(id);
  }, [ctx, id, color, priority, enabled]);
}
